/**
 * Ultimo stato (query) di ogni lista, per tornarci dalle pagine di inserimento e dettaglio.
 *
 * Si tiene in memoria e in sessionStorage: cosi' funziona anche se la scheda e' stata
 * ricaricata. sessionStorage puo' non esserci (navigazione privata, dati bloccati):
 * in quel caso resta solo la memoria e, al peggio, si torna alla lista dalla prima pagina.
 */
const KEY = 'listReturn:';
const memory = {};

export function rememberListRoute(path, query) {
	memory[path] = query;
	try {
		sessionStorage.setItem(KEY + path, JSON.stringify(query));
	} catch (e) {
		// niente sessionStorage: basta la memoria
	}
}

/** La location della lista com'era stata lasciata; senza ricordi, la lista nuda. */
export function listReturnLocation(path) {
	let query = memory[path];
	if (!query) {
		try {
			query = JSON.parse(sessionStorage.getItem(KEY + path) || 'null');
		} catch (e) {
			query = null;
		}
	}
	return { path, query: query || {} };
}

/**
 * Torna alla lista: con il "indietro" del browser se la scheda e' stata aperta dalla
 * lista (cosi' la cronologia resta pulita), altrimenti navigando all'ultimo stato noto.
 */
export function backToList(router, path, cameFromList) {
	if (cameFromList) {
		router.back();
	} else {
		router.push(listReturnLocation(path)).catch(() => {});
	}
}
